import { useState, useCallback } from 'react';
import razorpayService from '../services/razorpayService';
import { PaymentData } from '../types/razorpay';

interface UsePaymentReturn {
  isLoading: boolean;
  initiatePayment: (paymentData: PaymentData) => Promise<void>;
  error: string | null;
  clearError: () => void;
}

export const usePayment = (): UsePaymentReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const initiatePayment = useCallback(async (paymentData: PaymentData) => {
    try {
      setIsLoading(true);
      setError(null);
      await razorpayService.initiatePayment(paymentData);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Payment failed';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    isLoading,
    initiatePayment,
    error,
    clearError
  };
};